import { documentPermissionMap } from "@/components/CheckPermission/enum";
import { effectivePermissionsState } from "@/store/permissions";
import { hasPermission } from "@/utils/session-permissions";
import { useRecoilValue } from "recoil";

const useUserPermission = () => {
  const permissions = useRecoilValue(effectivePermissionsState);

  const CheckPermission = (permission: string, lineOfBusinessId?: string) =>
    hasPermission(permissions, permission, lineOfBusinessId);

  const CheckDocumentPermission = (documentType: string, permission: string) => {
    const specificPermissionMap = documentPermissionMap[permission];
    if (!specificPermissionMap) {
      return false;
    }

    const requiredPermission = specificPermissionMap[documentType];
    return requiredPermission ? CheckPermission(requiredPermission) : true;
  };

  return {
    CheckPermission,
    CheckDocumentPermission,
  };
};
export { useUserPermission };
